import { section } from "@/neon";
import { qs, qsa, toggle, listen } from "@fluorescent/dom";

import { emit, on } from "@/neon/events";
import disclosure from "@/components/disclosure";
import debounce from "@/lib/debounce";

const slideshowOpts = {
  adaptiveHeight: false,
  pageDots: false,
  prevNextButtons: false,
  wrapAround: true,
  draggable: false,
};

const selectors = {
  sliderContainer: ".utility-bar__announcements",
  announcements: ".utility-bar__announcement-item",
  socialContainer: ".utlity-bar__social-icons",
  disclosureContainer: ".utility-bar__disclosure-container",
  disclosure: "[data-disclosure]",
};

const modifiers = {
  active: "is-active",
  hidden: "is-hidden",
};

const rootVars = {
  utilityBar: "--utility-bar-height",
};

section("utility-bar", {
  crossBorder: {},
  onLoad() {
    this.sliderContainer = qs(selectors.sliderContainer, this.container);
    this.announcements = qsa(selectors.announcements, this.container);
    this.events = [
      listen(window, "resize", debounce(this._matchContentWidths, 150)),
    ];

    this._matchContentWidths();
    this._setUtilityBarVars();

    if (this.announcements.length) {
      this._initSlider();
    }

    // Wire up Cross Border disclosures
    const cbSelectors = qsa(selectors.disclosure, this.container);
    if (cbSelectors) {
      cbSelectors.forEach(selector => {
        const { disclosure: d } = selector.dataset;
        this.crossBorder[d] = disclosure(selector, this.container);
      });
    }

    on("sticky-header:stuck", () =>
      Object.keys(this.crossBorder).forEach(t => {
        this.crossBorder[t].hideList();
      })
    );
  },

  _initSlider() {
    import(flu.chunks.flickity).then(({ Flickity }) => {
      const { timing } = this.container.dataset;

      slideshowOpts.autoPlay = parseInt(timing, 10);

      this.slideshow = new Flickity(this.sliderContainer, {
        ...slideshowOpts,
        on: {
          // Need to add a modifier to animate after the first slide has changed
          change: index => {
            this.announcements.forEach((element, i) => {
              toggle(element, modifiers.active, i === index);

              element.setAttribute("aria-hidden", false);
              if (element.className.indexOf(modifiers.active) >= 0) {
                element.setAttribute("aria-hidden", true);
              }
            });
          },
        },
      });
    });
  },

  _setRootVar(name, value) {
    document.documentElement.style.setProperty(name, `${value}px`);
  },

  _setUtilityBarVars() {
    document.documentElement.style.removeProperty(rootVars.utilityBar);
    this._setRootVar(rootVars.utilityBar, this.container.offsetHeight);
    emit("sticky-header:reload", () => {});
  },

  _matchContentWidths() {
    // To keep our announcements fully centered we must ensure both elements
    // on either side are the same width.
    const socialContainer = qs(selectors.socialContainer, this.container);
    const disclosureContainer = qs(
      selectors.disclosureContainer,
      this.container
    );

    const socialWidth = socialContainer.offsetWidth;
    const disclosureWidth = disclosureContainer.offsetWidth;

    if (socialWidth === disclosureWidth) return;

    if (socialWidth > disclosureWidth) {
      disclosureContainer.setAttribute("style", `width:${socialWidth}px`);
    } else {
      socialContainer.setAttribute("style", `width:${disclosureWidth}px`);
    }
  },

  onBlockSelect({ target }) {
    this.slideshow.pausePlayer();
    this.slideshow.select(target.dataset.index);
  },

  onBlockDeselect() {
    this.slideshow.unpausePlayer();
  },

  onUnload() {
    this.slideshow && this.slideshow.destroy();
    this.resizeObserver && this.resizeObserver.disconnect();
    Object.keys(this.crossBorder).forEach(t => {
      this.crossBorder[t].unload();
    });
  },
});
